module.exports = __webpack_public_path__ + "img/empty.496d7d3a.png";